export default __webpack_public_path__ + "static/media/dev.6068f26c.png";